import React from 'react';
import PublicLayout from '../components/public/PublicLayout';
import { Link } from 'react-router-dom';
import presidentImage from '../assets/president.jpg';

const PresidentMessagePage = () => {
  return (
    <PublicLayout>
      <div className="py-5" style={{ background: 'linear-gradient(135deg, #f0f9ff 0%, #ffffff 100%)' }}>
        <div className="container">
          {/* Header */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <h1 className="display-4 fw-bold text-dark mb-3">President's Message</h1>
              <p className="lead text-muted">A Message from Dorothy H. Bendah, President of ARCA</p>
            </div>
          </div>

          {/* President Info & Full Message */}
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card shadow-lg border-0">
                <div className="row g-0">
                  {/* President Image */}
                  <div className="col-md-5">
                    <div className="position-relative overflow-hidden" style={{ minHeight: '400px', maxHeight: '600px' }}>
                      <img
                        src={presidentImage}
                        alt="Dorothy H. Bendah, President of ARCA"
                        className="img-fluid w-100"
                        style={{ objectFit: 'cover', objectPosition: 'center top', height: '100%' }}
                      />
                    </div>
                  </div>

                  {/* President Bio */}
                  <div className="col-md-7">
                    <div className="card-body p-4 p-lg-5">
                      <div className="mb-4 pb-3 border-bottom">
                        <h2 className="h3 fw-bold text-primary mb-2">Dorothy H. Bendah, BSc RT, MSRT, Int. Flw</h2>
                        <p className="text-muted mb-0">President, Africa Respiratory Care Association (ARCA)</p>
                      </div>

                      <div className="mb-4">
                        <h4 className="fw-bold text-dark mb-3">Dear ARCA Members and Friends,</h4>

                        <p className="text-dark mb-3">
                          It is with great honor and humility that I serve as the President of the African Respiratory
                          Care Association (ARCA). As we continue our mission to advance respiratory care across the
                          African continent, I am constantly reminded of the vital role each one of you plays in making
                          our vision a reality.
                        </p>

                        <p className="text-dark mb-3">
                          At ARCA, we believe that <strong>every breath matters</strong>. This simple yet profound truth
                          drives everything we do. From providing world-class education and training to respiratory care
                          professionals, to advocating for better healthcare policies, to ensuring that life-saving
                          equipment reaches those who need it most – our work is centered on one goal: improving the
                          quality of respiratory care for all Africans.
                        </p>

                        <p className="text-dark mb-3">
                          The challenges we face are significant. Respiratory diseases continue to be a leading cause
                          of morbidity and mortality across Africa. The COVID-19 pandemic has further highlighted the
                          critical need for skilled respiratory care professionals and adequate resources. Yet, in the
                          face of these challenges, I see tremendous opportunity.
                        </p>

                        <p className="text-dark mb-3">
                          Our organization has grown from a small group of dedicated professionals into a vibrant
                          network spanning over 25 countries. We have trained thousands of healthcare workers,
                          established chapters across the continent, and formed strategic partnerships with leading
                          global organizations. This growth is a testament to the dedication and passion of our members,
                          volunteers, and partners.
                        </p>

                        <h5 className="fw-bold text-primary mt-4 mb-3">Our Vision Moving Forward</h5>

                        <p className="text-dark mb-3">
                          As we continue to grow, our commitment to excellence in respiratory care remains unwavering. We envision a future where:
                        </p>

                        <ul className="list-unstyled mb-4">
                          <li className="mb-2">
                            <i className="fas fa-check-circle text-success me-2"></i>
                            Every African nation has a thriving respiratory care professional community
                          </li>
                          <li className="mb-2">
                            <i className="fas fa-check-circle text-success me-2"></i>
                            Access to quality respiratory care is a reality for all, regardless of location
                          </li>
                          <li className="mb-2">
                            <i className="fas fa-check-circle text-success me-2"></i>
                            African respiratory care professionals are globally recognized leaders in the field
                          </li>
                          <li className="mb-2">
                            <i className="fas fa-check-circle text-success me-2"></i>
                            Research and innovation in respiratory care flourishes across the continent
                          </li>
                        </ul>

                        <p className="text-dark mb-3">
                          None of this would be possible without your support. Whether you are a member, a volunteer,
                          a partner organization, or a donor, you are part of the ARCA family. Your contributions –
                          of time, expertise, and resources – are making a real difference in the lives of millions
                          of people across Africa.
                        </p>

                        <p className="text-dark mb-4">
                          I invite you to join us in this vital mission. Together, we can create a future where every
                          African has access to quality respiratory care. Together, we can ensure that every breath
                          matters, and every life is valued.
                        </p>

                        <p className="text-dark mb-2">
                          With gratitude and determination,
                        </p>

                        <div className="mt-4">
                          <p className="fw-bold text-dark mb-1" style={{ fontSize: '1.1rem' }}>Dorothy H. Bendah, BSc RT, MSRT, Int. Flw</p>
                          <p className="text-muted mb-0">President</p>
                          <p className="text-muted mb-0">Africa Respiratory Care Association (ARCA)</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Call to Action */}
              <div className="row g-4 mt-4">
                <div className="col-md-4">
                  <div className="card h-100 border-primary">
                    <div className="card-body text-center p-4">
                      <div className="mb-3">
                        <i className="fas fa-user-plus fa-3x text-primary"></i>
                      </div>
                      <h5 className="fw-bold mb-2">Become a Member</h5>
                      <p className="text-muted mb-3">Join ARCA and be part of advancing respiratory care in Africa</p>
                      <Link to="/membership_registration" className="btn btn-primary">Join Now</Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card h-100 border-success">
                    <div className="card-body text-center p-4">
                      <div className="mb-3">
                        <i className="fas fa-hands-helping fa-3x text-success"></i>
                      </div>
                      <h5 className="fw-bold mb-2">Volunteer</h5>
                      <p className="text-muted mb-3">Contribute your time and skills to make a difference</p>
                      <Link to="/get-involved/volunteer" className="btn btn-success">Volunteer</Link>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card h-100 border-danger">
                    <div className="card-body text-center p-4">
                      <div className="mb-3">
                        <i className="fas fa-heart fa-3x text-danger"></i>
                      </div>
                      <h5 className="fw-bold mb-2">Donate</h5>
                      <p className="text-muted mb-3">Support our mission to improve respiratory care</p>
                      <Link to="/get-involved/donate" className="btn btn-danger">Donate</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default PresidentMessagePage;
